import './src/vaadin-avatar.js';
export * from './src/vaadin-avatar.js';
